import globalAxios from "../GlobalAxios";

const getRpApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/getrp');
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const tencentTrafficApi = async (params) => {
  try {
    // const res = await globalAxios.get('/api/statistics/tencentcdntraffic');
    const res = await globalAxios.get('/api/statistics/tencentcdntraffic-info', { params: params });
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const tencentTrafficDailyApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/traffic_daily');
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const tencentTrafficMonthlyApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/traffic_monthly');
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const encodingApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/encoding');
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}


const storageApi = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/s3');
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const originApi = async (metricParams) => {
  try {
    const res = await globalAxios.get('/api/statistics/tencentorigin', { params: metricParams });
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const cdnApi = async (metricParams) => {
  try {
    const res = await globalAxios.get('/api/statistics/tencentcdn', { params: metricParams });
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const encodingDatePickerApi = async (params) => {
  try {
    const res = await globalAxios.get('/api/statistics/encoding-info', { params: params });
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const serviceUsageApi = async (params) => {
  try {
    const res = await globalAxios.post('/api/statistics/service-usage', params);
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}

const startService = async () => {
  try {
    const res = await globalAxios.get('/api/statistics/service-info');
    if(res){
      return res.data;
    }
  } catch (error) {
    console.error("error", error);
  }
}


// // total Service stats api
// const vodStatsDateRangeApi = async (params) => {
//   try {
//     const res = await globalAxios.post('/api/statistics/vod-usage', params);
//     if(res){
//       return res.data;
//     }
//   } catch (error) {
//     console.error("error", error);
//   }
// }

// const hlsStatsDateRangeApi = async (params) => {
//   try {
//     const res = await globalAxios.post('/api/statistics/hls-usage', params);
//     if(res){
//       return res.data;
//     }
//   } catch (error) {
//     console.error("error", error);
//   }
// }

// const webrtcStatsDateRangeApi = async (params) => {
//   try {
//     const res = await globalAxios.post('/api/statistics/webrtc-usage', params);
//     if(res){
//       return res.data;
//     }
//   } catch (error) {
//     console.error("error", error);
//   }
// }



export default {
  getRpApi,
  tencentTrafficApi,
  tencentTrafficDailyApi,
  tencentTrafficMonthlyApi,
  storageApi,
  encodingApi,
  originApi,
  cdnApi,
  encodingDatePickerApi,
  // vodStatsDateRangeApi,
  // hlsStatsDateRangeApi,
  // webrtcStatsDateRangeApi,
  serviceUsageApi,
  startService
};